<template>
  <v-autocomplete
    :items="enabledServices"
    :rules="rules"
    :value="value"
    @change="handleSelectChange"
    hide-no-data
    item-text="title"
    item-value="id"
    label="Service">
    <template slot="selection" slot-scope="data">
      <v-chip
        :color="data.item.backgroundColor"
        class="chip--select-multi v-chip--small">
        <v-tooltip bottom>
            <span slot="activator" v-bind:style="{'color': data.item.fontColor}">
              {{ data.item.code }}
            </span>
          {{ data.item.title }}
          <dev-mode>
            {{data.item.id}}
          </dev-mode>
        </v-tooltip>
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
  import DevMode from "../DevMode";
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'service-select',
    components: {
      DevMode
    },
    props: {
      value: {
        type: String,
      },
      rules: {
        type: Array,
        default() {
          return []
        }
      },
      serviceFilter: {
        type: Function,
        default() {
          return services => true // enable all by default
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters({
        availableServices: 'coloredAvailableServices'
      }),
      enabledServices() {
        const result = _.filter(this.availableServices, s => this.serviceFilter(s));
        return result
      }
    },
    mounted() {
      this.fetchInitDataIfRequired()
    },
    methods: {
      ...mapActions({
        fetchInitDataIfRequired: 'fetchInitDataIfRequired'
      }),
      handleSelectChange(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ServiceSelect.vue